import { parsePhoneNumberFromString } from "libphonenumber-js";

const MobileNumberFormat = (contactNumber) => {
    console.log(`contactNumber`, contactNumber);
    
    if (!contactNumber || contactNumber == '+null') return "-";
    const phoneNumber = parsePhoneNumberFromString(contactNumber);
    return phoneNumber ? phoneNumber.formatInternational() : contactNumber;
};

export default MobileNumberFormat;